module.exports = __webpack_public_path__ + "img/H5696.81b450c2.jpg";